import React from "react";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

const ResponseBuilder = ({ responseJson }) => {
    
    const responseBody = ( responseJson && JSON.stringify(responseJson.responseBody, null, 2)) ?? "Response Body will display here for the relavant transaction request."

    return (
        <div>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="response-body-tab" data-bs-toggle="tab" data-bs-target="#response-body" type="button" role="tab" aria-controls="home" aria-selected="true">Body</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="response-headers-tab" data-bs-toggle="tab" data-bs-target="#response-headers" type="button" role="tab" aria-controls="profile" aria-selected="false">Headers</button>
                </li>
            </ul>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="response-body" role="tabpanel" aria-labelledby="response-body-tab" style={{ padding: "20px 10px" }}>
                    <div className="docs-code-block">
                        <pre className="shadow-lg rounded"><code className="language-dockerfile hljs" style={{ overflowX: "hidden" }}>
                            <div className="row code-header">
                                <div className="col-md-10 languages">

                                </div>
                                <div className="col-md-2">

                                </div>
                            </div>
                            <div>
                                <SyntaxHighlighter language="json" style={dracula} showLineNumbers={false}>
                                    {responseBody}
                                </SyntaxHighlighter>
                            </div>
                        </code></pre>
                    </div>
                </div>
                <div className="tab-pane fade" id="response-headers" role="tabpanel" aria-labelledby="response-headers-tab">
                    <div className="docs-code-block">
                        <pre className="shadow-lg rounded">
                            <code className="language-dockerfile hljs" style={{ color: "white" }}>
                                <table style={{ marginTop: "5px" }}>
                                    <tbody>
                                        {responseJson?.responseHeaders ? Object.keys(responseJson?.responseHeaders).map(key =>
                                            <tr>
                                                <td>{key}</td>
                                                <td>:{responseJson.responseHeaders[key].toString()}</td>
                                            </tr>
                                        ) : <span style={{ color: "orange" }}>NO HEADERS</span>}
                                    </tbody>
                                </table>
                            </code>
                        </pre>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResponseBuilder;